import { useEffect, useState } from "react";

// Phone = narrow viewport, or a touch device up to tablet-portrait width.
const QUERY = "(max-width: 767px), ((pointer: coarse) and (max-width: 1023px))";

const read = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(QUERY).matches : false);

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(read);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}

// Routes where the phone bottom-nav must stay out of the way.
export const MOBILE_NAV_HIDDEN_PREFIXES = ["/admin", "/checkout", "/marketing", "/tickets", "/proof", "/invoice", "/accounting", "/auth"];
export const mobileNavHidden = (pathname) => MOBILE_NAV_HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

export const openChat = () => window.dispatchEvent(new CustomEvent("kolt:open-chat"));
